import styled from 'styled-components';

import { FullScreenBackground } from './styled';

export const BackContainer = styled.div`
  position: absolute;
  inset: 0;
  overflow: hidden;
  z-index: -1;
`;

export const BackImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;

  &[data-apply-gradient='true'] {
    mask-image: linear-gradient(to top, transparent, var(--pageBackground));
  }
`;

export const StyledOverlay = styled(FullScreenBackground)`
  background-color: var(--pageBackground);
  overflow-x: hidden;
`;

export const ModalBody = styled.div`
  display: flex;
  justify-content: center;
  min-width: 100vw;
  height: 100vh;
  color: var(--pageParagraphForeground);
  text-align: center;
  position: relative;
  align-items: flex-start;
`;
